import { render, staticRenderFns } from "./vip-secret.vue?vue&type=template&id=a1850dfe&scoped=true&"
import script from "./vip-secret.vue?vue&type=script&lang=js&"
export * from "./vip-secret.vue?vue&type=script&lang=js&"
import style0 from "./vip-secret.vue?vue&type=style&index=0&id=a1850dfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1850dfe",
  null
  
)

export default component.exports